import { useQuery } from '@apollo/client';
import { HStack, Text } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import useCompanyContext from 'common/hooks/useCompanyContext';
import SunshineIcon from 'components/_core/SunshineIcon';
import Loader from 'components/Loader';

import { UpgradablePlanMultiWalletBadgeDocument } from './graphql/upgradablePlanMultiWalletBadge.gql';
import locales from './locales';

const MultiWalletUpsellBadge = () => {
  const { companyProfileId } = useCompanyContext();

  const { data, loading } = useQuery(UpgradablePlanMultiWalletBadgeDocument, {
    fetchPolicy: 'cache-and-network',
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId as string,
      feature: Feature.MultiWallet,
    },
  });

  if (loading && !data) {
    return <Loader />;
  }

  const lowestUpgradablePlanWithMultiWallet =
    data?.viewer.company.currentPlan.upgradablePlansWithFeatureAvailable[0]
      ?.brandName;

  if (!lowestUpgradablePlanWithMultiWallet) {
    throw new Error('The lowest upgradable plan has not been found');
  }

  return (
    <HStack
      backgroundColor="blue.800"
      borderRadius={40}
      paddingX="space-8"
      paddingY="space-2"
      spacing="space-4"
      width="fit-content"
    >
      <SunshineIcon color="white" name="star" size="icon-14" />
      <Text color="white" fontSize="font-13" fontWeight="weight-500">
        {locales.formatString(locales.badge, {
          planName: lowestUpgradablePlanWithMultiWallet,
        })}
      </Text>
    </HStack>
  );
};

export default MultiWalletUpsellBadge;
